import { Box, Flex, Heading } from '@chakra-ui/react';
import { Button, Image } from '@everlywell/ui-kit';
import FilterableMeasures from 'components/FilterableMeasures';
import { SectionHeader } from 'components/SectionHeader';
import { Link } from 'gatsby';
import React from 'react';

const MeasuresSection = (data: any) => (
  <Box py={[16, 20]} px={[4, 0]} bg={data.backgroundColor}>
    <SectionHeader
      title={data.headline}
      eyebrow={data.title}
      titleMaxWidth="725px"
    />
    <FilterableMeasures tests={data.container} />

    <Box py={10}>
      <Heading as="h3" size="lg" maxWidth="725px" textAlign="center" mx="auto">
        EverlyCare supports gap closure with virtual screening reviews,
        assessments, treatment and referrals
      </Heading>
    </Box>

    <Box
      p={4}
      borderWidth="1px"
      borderRadius="lg"
      backgroundColor="white"
      overflowX="scroll"
      maxWidth="976px"
      mx="auto"
    >
      <Flex
        justifyContent="space-between"
        flexDirection={['column', 'row', 'row']}
        alignItems={['flex-start', 'center', 'center']}
      >
        <Flex gap={4}>
          <Image
            src="https://images.ctfassets.net/6huuyzvsw0nv/1QbDeDBvszFsoUe9xIC5R7/35b860fc6fbc30008073a2abf36e36ae/virtual_visits.png"
            alt=""
            width="80px"
            height="80px"
            borderRadius="md"
          />
          <Box>
            <Heading size="md" mb={2}>
              EverlyCare virtual visits
            </Heading>
            <Flex gap={2} maxHeight="27.5px">
              {[
                'BPD',
                'CBP',
                'CHL',
                'COA',
                'COL',
                'GSD',
                'KED',
                'SSD',
                'SMD',
                'SMC',
              ].map((label) => (
                <Box
                  key={label}
                  bg="#E8E8E2"
                  px={3}
                  py={1.5}
                  borderRadius="full"
                  color="#545454"
                  fontSize="14px"
                  whiteSpace={label === 'SNS-E' ? 'nowrap' : undefined}
                >
                  {label}
                </Box>
              ))}
            </Flex>
          </Box>
        </Flex>
        <Button
          as={Link}
          to="/everlycare"
          backgroundColor="#F9F9F6"
          color="#0F0F0F"
          fontSize="16px"
          fontWeight="500"
          py={2}
          px={6}
          mt={[3, 0, 0]}
          borderRadius="full"
          _hover={{
            backgroundColor: '#F9F9F6',
          }}
        >
          Learn more
        </Button>
      </Flex>
    </Box>
  </Box>
);

export default MeasuresSection;
